import React from 'react';
import PropTypes from 'prop-types';
import FuzzySearch from 'containers/FuzzySearch';
import { t } from 'utils/getLiteral';
import Literal from 'components/literal';
import './styles.scss';

const CrudFuzzy = (props) => {
    const {
        list,
        onChange = () => null,
        input,
        readOnly,
        placeholder = 'cfm_placeholder_search',
        meta: { touched, error },
        filterOption,
        dataTest,
        autoFocus,
    } = props;

    const { value } = input;
    const cleanValue = typeof value === 'string' && value.length === 0 ? null : value;

    const hasError = touched && error;
    const fuzzyClassName = hasError ? 'input-error' : '';
    const onFuzzyChange = (val) => {
        input.onChange(val);
        onChange(val);
    };

    return (
        <div className="fm-crud-field-fuzzy">
            <FuzzySearch
                placeholder={t(placeholder)}
                onChange={onFuzzyChange}
                value={cleanValue}
                labelMode="horizontal"
                list={list}
                readOnly={readOnly}
                className={fuzzyClassName}
                filterOption={filterOption}
                dataTest={dataTest}
                autoFocus={autoFocus}
            />
            {hasError && (
                <p className="crud-error-message">
                    <Literal literal="cfm_label_required_field" />
                </p>
            )}
        </div>
    );
};

CrudFuzzy.propTypes = {
    input: PropTypes.shape({}).isRequired,
    onChange: PropTypes.func,
    readOnly: PropTypes.bool,
    placeholder: PropTypes.string,
    meta: PropTypes.shape({
        touched: PropTypes.bool,
        error: PropTypes.string,
    }),
    list: PropTypes.string,
};

export default CrudFuzzy;
